import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LineInputModel, View } from './cross-line.component';
import { v4 as uuid } from 'uuid';
import { Vector3, Vector2 } from 'three';
import { filter, map, tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class GroupedcrosslineService {
  crosslineSubject = new BehaviorSubject<LineInputModel[]>([
    {
      id: 'testLine',
      position: new Vector3(10, 10, 10),
      view: 'x',
      crosslineLength: 2,
    },
  ]);
  crosslineMain$ = this.crosslineSubject.asObservable();
  tempV3 = new Vector3(0, 0, 0);
  constructor() {}

  addCrossLine(z: number = 0): string {
    const crosslineName = uuid();
    this.crosslineSubject.next([
      ...this.crosslineSubject.value,
      {
        id: crosslineName,
        position: new Vector3(10, 10, z),
        view: 'x',
        crosslineLength: 2,
      },
    ]);
    return crosslineName;
  }

  updatePosition(id: string, point2: Vector2, view: View, crosslineLength: number = 2) {
    this.crosslineMain$
      .pipe(
        map(b => {
          this.tempV3 = this.updateViewPos(
            point2,
            b[this.lastIndex(b, id)].position,
            view,
          );
        }),
      )
      .subscribe();
    this.crosslineSubject.next([
      ...this.crosslineSubject.value,
      { id: id, position: this.tempV3, view: view, crosslineLength },
    ]);
  }
  position$(id: string, view: View): Observable<Vector2> {
    return this.crosslineMain$.pipe(
      map(b => this.getPos(b[this.lastIndex(b, id)].position, view)),
    );
  }
  position3$(id: string): Observable<Vector3> {
    return this.crosslineMain$.pipe(
      map(b => b[this.lastIndex(b, id)].position),
    );
  }
  getPos(pos3: Vector3, view: View) {
    switch (view) {
      case 'x':
        return new Vector2(pos3.y, pos3.x);
      case 'y':
        return new Vector2(pos3.x, pos3.z);
      case 'z':
        return new Vector2(pos3.x, pos3.y);
    }
  }
  lastIndex(b: LineInputModel[], id: string): number {
    let indexLast = 0;
    for (let i = 0; i < b.length; i++) {
      if (b[i].id === id) {
        indexLast = i;
      }
    }
    return indexLast;
  }
  updateViewPos(pos2: Vector2, pos3: Vector3, view: View): Vector3 {
    let pos3Temp = pos3;
    switch (view) {
      case 'x':
        pos3Temp = new Vector3(pos3.x, pos2.x, pos2.y);
        break;
      case 'y':
        pos3Temp = new Vector3(pos2.x, pos3.y, pos2.y);
        break;
      case 'z':
        pos3Temp = new Vector3(pos2.x, pos2.y, pos3.z);
        break;
      default:
        pos3Temp = new Vector3(pos3.x, pos2.x, pos2.y);
    }
    return pos3Temp;
  }
}
